import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import {StUiComponentsModule} from "./shared-components/ui-components/st-ui-components.module";
import {PagesModule} from "./pages/pages.module";
import {RouterOutlet} from "@angular/router";
import {AppRoutingModule} from "./app-routing.module";
import {ApiService} from "./services/api.service";
import {AuthService} from "./services/auth.service";
//import {AuthService, initializeAuth} from "./services/auth.service";
import {HttpClient, HttpClientModule, HttpHandler} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AsyncPipe} from "@angular/common";
import {BrowserAnimationsModule, NoopAnimationsModule} from "@angular/platform-browser/animations";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {AuthGuard} from "./routing/auth-guard.service";
import {Auth2Service} from "./services/auth2.service";

@NgModule({
  declarations: [
    AppComponent
  ],
  exports: [StUiComponentsModule, PagesModule],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AsyncPipe,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    AppRoutingModule,
    RouterOutlet,
    StUiComponentsModule,
    PagesModule,
    HttpClientModule,
    NgbModule
  ],
  providers: [ApiService, HttpClient,
  AuthService, AuthGuard, Auth2Service
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

/*
providers: [ApiService, HttpClient,
  AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      multi: true,
      deps: [AuthService]
    }
  ],
 */
